var _circle, _rect, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsentRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1924_8851)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 19.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1924_8851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -6,
    width: 70,
    height: 70
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 69.5,
    height: 69.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1924_8851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.751 32.81L37.161 41.22C37.6926 41.7517 38.3693 42.0175 39.191 42.0175C40.0126 42.0175 40.6893 41.7517 41.221 41.22C41.7526 40.6883 42.0185 40.0117 42.0185 39.19C42.0185 38.3683 41.7526 37.6917 41.221 37.16L32.811 28.75L41.221 20.34C41.7526 19.8083 42.0185 19.1317 42.0185 18.31C42.0185 17.4883 41.7526 16.8117 41.221 16.28C40.6893 15.7483 40.0126 15.4825 39.191 15.4825C38.3693 15.4825 37.6926 15.7483 37.161 16.28L28.751 24.69L20.341 16.28C19.8093 15.7483 19.1326 15.4825 18.311 15.4825C17.4893 15.4825 16.8126 15.7483 16.281 16.28C15.7493 16.8117 15.4835 17.4883 15.4835 18.31C15.4835 19.1317 15.7493 19.8083 16.281 20.34L24.691 28.75L16.281 37.16C15.7493 37.6917 15.4835 38.3683 15.4835 39.19C15.4835 40.0117 15.7493 40.6883 16.281 41.22C16.8126 41.7517 17.4893 42.0175 18.311 42.0175C19.1326 42.0175 19.8093 41.7517 20.341 41.22L28.751 32.81ZM28.751 57.75C24.7393 57.75 20.9693 56.9888 17.441 55.4663C13.9126 53.9438 10.8435 51.8775 8.23348 49.2675C5.62348 46.6575 3.55723 43.5883 2.03473 40.06C0.512227 36.5317 -0.249023 32.7617 -0.249023 28.75C-0.249023 24.7383 0.512227 20.9683 2.03473 17.44C3.55723 13.9117 5.62348 10.8425 8.23348 8.2325C10.8435 5.6225 13.9126 3.55625 17.441 2.03375C20.9693 0.51125 24.7393 -0.25 28.751 -0.25C32.7626 -0.25 36.5326 0.51125 40.061 2.03375C43.5893 3.55625 46.6585 5.6225 49.2685 8.2325C51.8785 10.8425 53.9447 13.9117 55.4672 17.44C56.9897 20.9683 57.751 24.7383 57.751 28.75C57.751 32.7617 56.9897 36.5317 55.4672 40.06C53.9447 43.5883 51.8785 46.6575 49.2685 49.2675C46.6585 51.8775 43.5893 53.9438 40.061 55.4663C36.5326 56.9888 32.7626 57.75 28.751 57.75Z",
    fill: "#EC0001"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1924_8851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentRejected);
export default __webpack_public_path__ + "static/media/ConsentRejected.e1953e87240db2902d6edfbaac34403e.svg";
export { ForwardRef as ReactComponent };